module.exports = __webpack_public_path__ + "fonts/VetoSans-MediumItalic_1.929feaeb.ttf";